
import { Helmet } from "react-helmet-async";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { MessageSquare, Phone, Mail } from "lucide-react";

const Contato = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-blue-50">
      <Helmet>
        <title>Entre em Contato | LocalUp - Especialistas em SEO Local</title>
        <meta name="description" content="Entre em contato com nossa equipe de especialistas em SEO Local e descubra como podemos ajudar seu negócio a ser mais encontrado online em sua região." />
        <meta name="keywords" content="contato SEO local, orçamento SEO local, consultoria SEO, agência marketing local" />
        <link rel="canonical" href="https://localup.com.br/contato" />
      </Helmet>
      
      <Navbar />
      
      {/* Hero da página de contato */}
      <section className="py-20 px-6 md:px-12 bg-gradient-to-br from-blue-50 to-indigo-100">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-3xl md:text-5xl font-bold mb-6 text-seo-dark bg-clip-text text-transparent bg-gradient-to-r from-seo-primary to-seo-secondary">Entre em Contato</h1>
          <p className="text-xl mb-8 text-gray-700">
            Estamos prontos para ajudar seu negócio a crescer online. Fale conosco!
          </p>
        </div>
      </section>

      {/* Informações de contato */}
      <section className="py-20 px-6 md:px-12 bg-white">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-3xl font-bold mb-12 text-center text-seo-dark">Fale Conosco</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Card de Telefone */}
            <div className="bg-gradient-to-br from-blue-50 to-blue-100 p-8 rounded-2xl shadow-lg border border-blue-200 transform transition-all duration-300 hover:-translate-y-2 hover:shadow-xl">
              <div className="bg-seo-primary/10 p-4 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-6">
                <Phone className="h-8 w-8 text-seo-primary" />
              </div>
              <h3 className="text-xl font-semibold text-center mb-4 text-seo-dark">Telefone</h3>
              <p className="text-lg text-center text-gray-700 font-medium">+55 11 5197-4403</p>
              <div className="mt-6 text-center">
                <a 
                  href="tel:+551151974403" 
                  className="inline-block text-seo-primary hover:underline"
                >
                  Ligar agora
                </a>
              </div>
            </div>
            
            {/* Card de WhatsApp */}
            <div className="bg-gradient-to-br from-green-50 to-green-100 p-8 rounded-2xl shadow-lg border border-green-200 transform transition-all duration-300 hover:-translate-y-2 hover:shadow-xl">
              <div className="bg-green-500/10 p-4 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-6">
                <MessageSquare className="h-8 w-8 text-green-500" />
              </div>
              <h3 className="text-xl font-semibold text-center mb-4 text-seo-dark">WhatsApp</h3>
              <p className="text-lg text-center text-gray-700 font-medium">Atendimento imediato</p>
              <div className="mt-6 text-center">
                <a 
                  href="https://wa.me/5555115197440?text=Ol%C3%A1%2C%20quero%20uma%20analise%20da%20LocalUP." 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="inline-block text-green-600 hover:underline"
                >
                  Enviar mensagem
                </a>
              </div>
            </div>
            
            {/* Card de Email */}
            <div className="bg-gradient-to-br from-purple-50 to-purple-100 p-8 rounded-2xl shadow-lg border border-purple-200 transform transition-all duration-300 hover:-translate-y-2 hover:shadow-xl">
              <div className="bg-seo-secondary/10 p-4 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-6">
                <Mail className="h-8 w-8 text-seo-secondary" />
              </div>
              <h3 className="text-xl font-semibold text-center mb-4 text-seo-dark">E-mail</h3>
              <p className="text-lg text-center text-gray-700 font-medium">contato@localup.com.br</p>
              <div className="mt-6 text-center">
                <a 
                  href="mailto:contato@localup.com.br" 
                  className="inline-block text-seo-secondary hover:underline"
                >
                  Enviar e-mail
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {/* CTA */}
      <section className="py-16 px-6 md:px-12 bg-gradient-to-r from-seo-primary to-seo-secondary text-white">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-bold mb-6">Precisa de ajuda com SEO Local?</h2>
          <p className="text-xl mb-8 text-white/90">
            Fale com nossa equipe de especialistas e descubra como podemos aumentar sua visibilidade online.
          </p>
          <Button 
            onClick={() => window.open('https://wa.me/5555115197440?text=Ol%C3%A1%2C%20quero%20uma%20analise%20da%20LocalUP.', '_blank')}
            className="bg-white text-seo-primary hover:bg-white/90 text-lg px-8 py-6 rounded-lg shadow-lg flex items-center mx-auto gap-2"
            size="lg"
          >
            <MessageSquare className="w-5 h-5" /> Fale com um especialista
          </Button>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Contato;
